import type { DatePickerProps } from 'antd'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useUiKitContext } from '../../utils/UiKitProvider/UiKitProvider'
import NextReviewField from '.'

const BASE_TRANSLATE = 'consent.createConsentForms.components.consentModal.'
const FORMAT = 'YYYY-MM-DD'

const now = dayjs()

const noFurtherSupportValue = 'null'

export const getTimeOptions = (translate: any) => [
  {
    label: translate(`${BASE_TRANSLATE}threeMonth`),
    value: now.add(3, 'month').format(FORMAT)
  },
  {
    label: translate(`${BASE_TRANSLATE}sixMonths`),
    value: now.add(6, 'month').format(FORMAT)
  },
  {
    label: translate(`${BASE_TRANSLATE}oneYear`),
    value: now.add(1, 'year').format(FORMAT)
  },
  {
    label: translate(`${BASE_TRANSLATE}noFurtherSupport`),
    value: noFurtherSupportValue
  }
]

/**
 * @deprecated
 */
const NextReviewInputOld = (props: NextReviewInputProps) => {
  const { onChange, value, disabledDate } = props

  const [nextReviewDate, setNextReviewDate] = useState<string | undefined>(
    value
  )

  const timeOptionDefault = value === noFurtherSupportValue ? value : undefined

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    setNextReviewDate(value)

    if (timeOptionDefault) {
      setTimeOptionNextReview(value)
    }
  }, [value])

  const [timeOptionNextReview, setTimeOptionNextReview] = useState<
    string | undefined
  >()
  const handleDateChange = (date: any, dateString: any) => {
    if (date !== null) {
      setNextReviewDate(dateString)
      onChange?.(dateString)
    } else {
      setTimeOptionNextReview(undefined)
      setNextReviewDate(undefined)
      onChange?.(undefined)
    }
  }

  const handleRadio = (newValue: string) => {
    setTimeOptionNextReview(newValue)
    setNextReviewDate(newValue)
    onChange?.(newValue)
  }

  const { translation } = useUiKitContext()

  return (
    <NextReviewField
      disabledDate={disabledDate}
      format="YYYY-MM-DD"
      localisation={{
        title: 'Next review',
        additionalInfo: 'Any additional comments on this review?'
      }}
      dateValue={nextReviewDate}
      datePickerOnChange={handleDateChange}
      radioGroupOnChange={handleRadio}
      timeValue={timeOptionNextReview}
      timeOptions={getTimeOptions(translation)}
    />
  )
}

type NextReviewInputProps = {
  disabledDate?: DatePickerProps['disabledDate']
  onChange?: (value: string | undefined) => void
  value?: string
}

export default NextReviewInputOld
